import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IVendor, IVendorReq, IVendorType } from '@/models/vendors';

import { http } from './http';
import { IGetParams, IListResponse, IPaginatedListResponse } from './types';

export const VendorApi = {
  list: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IVendor>>> => {
    return http.get(`api/${ApiVersion.V1}/vendors`, { params });
  },
  paginatedList: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IVendor>>> => {
    return http.get(`api/${ApiVersion.V1}/vendors/list`, { params });
  },
  getOne: async (id: string): Promise<AxiosResponse<IVendor>> => {
    return http.get(`api/${ApiVersion.V1}/vendors/${id}`);
  },
  getTypes: async (): Promise<AxiosResponse<IVendorType[]>> => {
    return http.get(`api/${ApiVersion.V1}/vendors/types`);
  },
  save: async (data: IVendorReq): Promise<AxiosResponse<IVendor>> => {
    return data._id ? VendorApi.update(data._id, data) : VendorApi.create(data);
  },
  create: async (data: IVendorReq): Promise<AxiosResponse<IVendor>> => {
    return http.post(`api/${ApiVersion.V1}/vendors`, data);
  },
  update: async (
    id: string,
    data: IVendorReq,
  ): Promise<AxiosResponse<IVendor>> => {
    return http.put(`api/${ApiVersion.V1}/vendors/${id}`, data);
  },
  delete: async (id: string): Promise<AxiosResponse> => {
    return http.delete(`api/${ApiVersion.V1}/vendors${id}`);
  },
};
